import axios from "axios";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Fileupload from "./Fileupload";
import { url } from "../link";
const Updateproject2023 = () => {
  var rx = 0;
  const { state } = useLocation();
  const [pid, setpid] = useState(state[rx++]);
  const [name, setname] = useState(state[rx++]);
  const [phone_number, setphone_number] = useState(state[rx++]);
  const [college, setcollege] = useState(state[rx++]);
  const [project_title, setproject_title] = useState(state[rx++]);
  const [total_amount, settotal_amount] = useState(state[rx++]);
  const [total_paid, settotal_paid] = useState(state[rx++]);
  const [balance, setbalance] = useState(state[rx++]);
  const [vendor, setvendor] = useState(state[rx++]);
  const [vendortotal, setvendortotal] = useState(state[rx++]);
  const [paid, setpaid] = useState(state[rx++]);
  const [project_status, setproject_status] = useState(state[rx++]);
  const [report, setreport] = useState(state[rx++]);
  const [filename, setfilename] = useState(state[rx++]);
  const [ppt, setppt] = useState(state[rx++]);
  const nav = useNavigate();
  const submitdata = () => {
    const value = {
      pid: pid,
      name: name,
      phone_number: phone_number,
      college: college,
      project_title: project_title,
      total_amount: total_amount,
      total_paid: total_paid,
      balance: balance,
      vendor: vendor,
      vendortotal: vendortotal,
      paid: paid,
      project_status: project_status,
      report: report,
      filename: filename,
      ppt: ppt,
    };
    axios.post(url + "/edusphere/updateproject2023", value).then((response) => {
      nav("/viewproject2023");
    });
  };

  return (
    <div>
      <h1>Add project2023</h1>
      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setpid(e.target.value)}
          value={pid}
          placeholder="Enter pid"
        />
        <label htmlFor="pid">pid</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setname(e.target.value)}
          value={name}
          placeholder="Enter name"
        />
        <label htmlFor="name">name</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setphone_number(e.target.value)}
          value={phone_number}
          placeholder="Enter phone_number"
        />
        <label htmlFor="phone_number">phone_number</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setcollege(e.target.value)}
          value={college}
          placeholder="Enter college"
        />
        <label htmlFor="college">college</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setproject_title(e.target.value)}
          value={project_title}
          placeholder="Enter project_title"
        />
        <label htmlFor="project_title">project_title</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => settotal_amount(e.target.value)}
          value={total_amount}
          placeholder="Enter total_amount"
        />
        <label htmlFor="total_amount">total_amount</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => settotal_paid(e.target.value)}
          value={total_paid}
          placeholder="Enter total_paid"
        />
        <label htmlFor="total_paid">total_paid</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setbalance(e.target.value)}
          value={balance}
          placeholder="Enter balance"
        />
        <label htmlFor="balance">balance</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setvendor(e.target.value)}
          value={vendor}
          placeholder="Enter vendor"
        />
        <label htmlFor="vendor">vendor</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setvendortotal(e.target.value)}
          value={vendortotal}
          placeholder="Enter vendortotal"
        />
        <label htmlFor="vendortotal">vendortotal</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setpaid(e.target.value)}
          value={paid}
          placeholder="Enter paid"
        />
        <label htmlFor="paid">paid</label>
      </div>
      <h1>Kindly upload only zip file</h1>
      <div className="row">
        <div className=" mb-3 mt-3 col">
          <label htmlFor="project_status">Base Paper</label>
          <Fileupload
            name={project_title + "base"}
            setdata={setproject_status}
          />
        </div>

        <div className=" mb-3 mt-3 col">
          <label htmlFor="project_status">Report</label>
          <Fileupload name={project_title + "report"} setdata={setreport} />
        </div>
      </div>
      <div className="row">
        <div className=" mb-3 mt-3 col">
          <label htmlFor="project_status">Projectfile</label>
          <Fileupload name={project_title + "pro"} setdata={setfilename} />
        </div>

        <div className=" mb-3 mt-3 col">
          <label htmlFor="project_status">Ppt</label>
          <Fileupload name={project_title + "ppt"} setdata={setppt} />
        </div>
      </div>
      <div className="row">
        <input
          type="submit"
          className="btn btn-primary col"
          onClick={submitdata}
          style={{ width: "50%" }}
        />
        <input
          type="submit"
          className="btn btn-danger col"
          onClick={() => {
            axios
              .post(url + "/edusphere/deleteproject2023", {
                id: state[0],
              })
              .then((response) => {
                nav("/viewproject2023");
              });
          }}
          value="delete"
          style={{ width: "50%" }}
        />
      </div>
    </div>
  );
};
export default Updateproject2023;
